/* eslint-disable max-lines */

import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import type { Renderable } from '@adornis/functional-lit/renderable.js';
import type { ILSThemeDefinition } from '@ils/theme/theme.js';
import { html } from 'lit';
import { ifDefined } from 'lit/directives/if-defined.js';

export const squareIcon = (
  host: ChemistryLitElement<ILSThemeDefinition>,
  icon: string,
  options: {
    size?: string;
    color?: string;
    title?: string;
    onClick?: () => void;
    slotted?: Renderable;
    isSelected?: boolean;
  },
) => html`
  <x-flex
    title=${ifDefined(options.title)}
    horizontal
    crossaxis-center
    space="xs"
    padding="xs"
    ${css({
      fontSize: options.size ?? '1rem',
      cursor: 'pointer',
      borderRadius: host.sizes.borderRadius,
      background: options.isSelected ? options.color ?? host.colors.neutral.shade(200) : 'transparent',
      border: `2px solid ${options.isSelected ? 'transparent' : options.color ?? host.colors.neutral.shade(200)}`,
      color: options.isSelected ? 'white' : options.color ?? host.colors.neutral.shade(200),
    })}
    @click=${() => options.onClick?.()}
  >
    <x-icon> ${icon} </x-icon>
    ${options.slotted}
  </x-flex>
`;
